import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessDeniedComponent } from './modules/not-found/access-denied.component';
import { StartupErrorComponent } from './modules/not-found/startup-error.component';
import { SystemUnavailableComponent } from './modules/not-found/system-unavailable.component';
import { MainComponent } from './modules/main/main.component';

// Task 2616 Phase 7 — static error routes must appear BEFORE ':companyName'.
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: MainComponent,
  },
  // Static routes — must stay above ':companyName'.
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'startup-error',
    component: StartupErrorComponent,
  },
  {
    path: 'system-unavailable',
    component: SystemUnavailableComponent,
  },
  {
    path: ':companyName',
    loadChildren: () =>
      import('../../../shared/src/lib/modules/layout/layout.module').then(
        (m) => m.LayoutModule,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
